export default __webpack_public_path__ + "static/media/procurementService.bc97287b.png";